// Assets/gift-auto.js
(function () {
  const THRESHOLD_CENTS = 15000; // 150 €
  const GIFT_VARIANT_ID =  15132004516172; // <-- BYT till ditt Variant ID
  const GIFT_QTY = 1;
  let isUpdating = false;

  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    return r.json();
  }

  async function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: GIFT_QTY, properties: { _gift: 'true' } })
    });
  }

  async function removeGift(line) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line, quantity: 0 })
    });
  }

  function hasGift(cart) {
    return cart.items.findIndex(i => i.variant_id === GIFT_VARIANT_ID) !== -1;
  }

  function giftLineIndex(cart) {
    return cart.items.findIndex(i => i.variant_id === GIFT_VARIANT_ID) + 1; // /change.js uses 1-based index
  }

  async function syncGift() {
    if (isUpdating) return;
    isUpdating = true;
    try {
      const cart = await getCart();
      const meets = cart.items_subtotal_price >= THRESHOLD_CENTS;
      const giftInCart = hasGift(cart);

      if (meets && !giftInCart) {
        await addGift();
        document.dispatchEvent(new CustomEvent('cart:refresh')); // låt temat uppdatera vyn
      } else if (!meets && giftInCart) {
        await removeGift(giftLineIndex(cart));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    } catch (e) {
      console.warn('Gift sync failed', e);
    } finally {
      isUpdating = false;
    }
  }

  // Kör vid sidladdning
  document.addEventListener('DOMContentLoaded', syncGift);

  // Hooka in vanliga cart-uppdateringar (Symmetry uppdaterar via Ajax)
  ['cart:updated', 'cart:refresh'].forEach(evt =>
    document.addEventListener(evt, syncGift)
  );

  // Fånga vanliga formulär/knappar som ändrar carten
  document.addEventListener('change', (e) => {
    if (e.target && (e.target.name === 'updates[]' || e.target.closest('form[action="/cart"]'))) {
      setTimeout(() => document.dispatchEvent(new Event('cart:updated')), 300);
    }
  });

  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest('form[action^="/cart/add"] button, button[name="add"], .product-form__submit');
    const qtyBtn = e.target.closest('[name="plus"], [name="minus"], .qty__button');
    const removeBtn = e.target.closest('[data-remove], [name="remove"]');
    if (addBtn || qtyBtn || removeBtn) {
      setTimeout(() => document.dispatchEvent(new Event('cart:updated')), 400);
    }
  });
})();
